var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{staticClass:"bg-[#0d121d]",attrs:{"width":"15%"}},[_c('Aside')],1),_c('el-main',{staticClass:"bg-[#0d121d] h-[80rem]"},[_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }